<script setup>
  const props = defineProps({
    fighter: Object,
    winner: Boolean,
    inWhiteCorner: Boolean,
    large: Boolean,
    withdrawn: Boolean,
    forceActive: Boolean,
  });
</script>

<!----------------------------------------------------------------------------->

<template>
  <ClickableCard :to="fighter?.url">
    <FighterThumbnailFight
      :fighter="fighter"
      :winner="winner"
      :forceActive="forceActive"
      :inWhiteCorner="inWhiteCorner"
      :largeLabel="large"
      noGradientMobile
    />
    <div class="name">
      <h4 v-if="withdrawn">Withdrawn</h4>
      <h4 v-else>{{ fighter?.last_name ?? 'TBD' }}</h4>
    </div>
  </ClickableCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  a {
    box-sizing: content-box;

    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;

    .name {
      height: px(72);
      border-top: px(1) solid $black-5;

      @include heroic-bold(px(24));

      display: flex;
      align-items: center;
      justify-content: center;

      background-color: $black-2;

      h4 {
        margin-top: 0.08em;
      }
    }

    @include break-medium {
      .name {
        height: px(64);
      }
    }

    @include break-small {
      .name {
        h4 {
        }
      }
    }

    @include break-phone {
      .name {
        height: px(60);
        h4 {
          font-size: px(32);
        }
      }
    }
  }
</style>
